// src/pages/Blogs/BlogDetails.jsx

import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getBlogById } from "./BlogService";
import MainLayout from "../../layouts/MainLayout";
import PageLoader from "../../components/Loader/PageLoader";
import "./Blogs.css";

export default function BlogDetails() {
  const { id } = useParams();
  const [blog, setBlog]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      const res = await getBlogById(id);
      setBlog(res.blog);
      setLoading(false);
    };
    load();
  }, [id]);

  if (loading) {
    return (
      <MainLayout>
        <PageLoader label="Loading article…" />
      </MainLayout>
    );
  }

  if (!blog) {
    return (
      <MainLayout>
        <div className="blog-state-wrap">
          <span style={{ fontSize: "1.8rem" }}>📭</span>
          <p>Blog not found</p>
          <Link to="/blogs" className="blog-back-link" style={{ marginBottom: 0 }}>
            ← Back to Blogs
          </Link>
        </div>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <div className="blog-detail-wrapper">

        {/* HERO IMAGE */}
        {blog.thumbnail && (
          <div className="blog-hero">
            <img src={blog.thumbnail} alt={blog.title} />
          </div>
        )}

        {/* MAIN CONTENT */}
        <div className="blog-container">

          {/* Back link */}
          <Link to="/blogs" className="blog-back-link">
            ← Back to Blogs
          </Link>

          {/* Title */}
          <h1 className="blog-title">{blog.title}</h1>

          {/* Meta pills */}
          <div className="blog-meta">
            {blog.doctorName && (
              <span className="blog-meta-pill">👨‍⚕️ {blog.doctorName}</span>
            )}
            {blog.partnerName && (
              <span className="blog-meta-pill">🏢 {blog.partnerName}</span>
            )}
            {blog.type && (
              <span className="blog-meta-pill" style={{
                background: "#e0f2fe",
                borderColor: "#bae6fd",
                color: "#0369a1",
              }}>
                📌 {blog.type}
              </span>
            )}
            {blog.dateTime && (
              <span className="blog-meta-pill">
                📅 {new Date(blog.dateTime).toLocaleDateString("en-PK", {
                  year: "numeric", month: "long", day: "numeric",
                })}
              </span>
            )}
          </div>

          {/* Divider */}
          <div className="blog-divider" />

          {/* Body */}
          <div
            className="blog-body"
            dangerouslySetInnerHTML={{ __html: blog.content }}
          />

        </div>
      </div>
    </MainLayout>
  );
}